export default "__VITE_ASSET__CI4SSa_q__"